import {omit} from 'lodash';

import {DelegationModel} from '../../../models/api/delegationModel';
import {AppAction} from '../../appActions';
import {ResourceMap} from '../../appTypes';
import {DelegationsActionsEnum} from './delegationsActions';

export function delegationsReducer(
  state: ResourceMap<DelegationModel>,
  action: AppAction,
): ResourceMap<DelegationModel> {
  switch (action.type) {
    // Single delegation update.
    case DelegationsActionsEnum.DELEGATION_UPDATED:
      return {
        ...state,
        [action.payload.delegation.id]: action.payload.delegation,
      };

    // Single delegation deletion.
    case DelegationsActionsEnum.DELEGATION_DELETED:
      return omit(state, action.payload);

    default:
      return state;
  }
}
